var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V5ZM15 5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7V5ZM6 7V6H4.84211C4.37702 6 4 6.36872 4 6.82354V19.1765C4 19.6313 4.37702 20 4.8421 20H19.1579C19.623 20 20 19.6313 20 19.1765V6.82354C20 6.36872 19.623 6 19.1579 6H18V7C18 8.10457 17.1046 9 16 9C14.8954 9 14 8.10457 14 7V6H10V7C10 8.10457 9.10457 9 8 9C6.89543 9 6 8.10457 6 7Z",
    fill: "#E0E1EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiry);
export default __webpack_public_path__ + "static/media/expiry.03c34972.svg";
export { ForwardRef as ReactComponent };